import { useAuth } from '@clerk/clerk-react';
import { trpc } from '@/shared/api/trpc';

const devBypassAuth = import.meta.env.VITE_DEV_BYPASS_AUTH === 'true';

export const useAuthData = () => {
  const { isSignedIn } = useAuth();
  return trpc.auth.me.useQuery(undefined, {
    enabled: devBypassAuth || !!isSignedIn,
  });
};
